import type { ReactNode } from 'react';

import { SignInFrame } from './sign-in-frame';

interface SignInLayoutProps {
  /** The full product name, shown as the page's one h1: "Cyrino Platform". */
  appName: string;
  /** One line on what the app is for. */
  description: string;
  /** The notice and the sign-in button; each app owns its own logic. */
  children: ReactNode;
}

/**
 * The branded sign-in page shared by every SPA. Presentational only: the
 * session probe, the redirect and the button's behaviour stay in the app.
 */
export function SignInLayout({ appName, description, children }: SignInLayoutProps) {
  return (
    <SignInFrame tagline={description}>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <h1 className="text-display text-foreground lg:text-4xl">{appName}</h1>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>

        <div className="flex flex-col gap-4">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Sign in with your work account
          </p>
          {children}
        </div>
      </div>
    </SignInFrame>
  );
}
